



















































































import Vue from "vue";
import _ from "lodash";
import * as a from "@/store/modules/UpdatePackagesModule/actions";
import { mapActions } from "vuex";
import moment from "moment";

import { MODULE_COLORS } from "@/utility/Constants";
import { GetI18nStringFromUpdateType, UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";

// UI Component
import UpdatePackageAssociationCheckbox from "./UpdatePackageAssociationCheckbox.vue";
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import UpdateTypeFilter from "@/components/TableHeaderFilters/UpdateTypeFilter.vue";

// Model
import { Installation } from "@/model/data/Installation";
import { VersionObfuscator } from "@/model/data/updates/VersionObfuscator";
import { UpdatePackageAssociationEnum } from "@/model/data/updates/UpdatePackageAssociationEnum";
import { FetchAssociatedUpdatePackagesCommand } from "@/model/communication/updatePackages/fetchAssociatedUpdatePackages/FetchAssociatedUpdatePackagesCommand";
import { FetchAssociatedUpdatePackagesReqData } from "@/model/communication/updatePackages/fetchAssociatedUpdatePackages/FetchAssociatedUpdatePackagesReqData";
import { SetInstallationsPackagesCommand } from "@/model/communication/updatePackages/setInstallationsPackages/SetInstallationsPackagesCommand";
import { SetInstallationsPackagesReqData } from "@/model/communication/updatePackages/setInstallationsPackages/SetInstallationsPackagesReqData";
import { UpdatePackageAssociation } from "@/model/data/updates/UpdatePackageAssociation";

export default Vue.extend({
    components: {
        UpdatePackageAssociationCheckbox,
        TableFiltersRow,
    },
    props: {
        installations: Array as () => Installation[],
        hideCancel: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            moment,
            UpdateTypeEnum,
            loading: false,
            MODULE_COLORS,
            VersionObfuscator,
            UpdatePackageAssociationEnum,
            tab: 0,
            originalAssociationPackages: [],
            associationPackages: [],
            headers: [
                { text: "", value: "packageIcon", sortable: false },
                { text: "", value: "association", sortable: false },
                { text: this.$t("common.file_name"), value: "fileName" },
                {
                    text: this.$t("update_packages.update_type"),
                    value: "updateType",
                },
                {
                    text: this.$t("update_packages.version"),
                    value: "version",
                    sortable: false,
                },
                {
                    text: this.$t("update_packages.uploadedAt"),
                    value: "uploadTimestamp",
                    sortable: true,
                    align: "center",
                },
            ],
            filters: [
                {
                    headerValue: "updateType",
                    filterKey: "updateTypeFilter",
                    component: UpdateTypeFilter,
                    currentSelections: [],
                },
            ],
            search: "",
            options: {},
            updateTypeFilter: [],
        };
    },
    computed: {
        areAllChangesSaved() {
            return _.isEqual(
                this.associationPackages.map((c) => c.association),
                this.originalAssociationPackages.map((c) => c.association)
            );
        },
        updatePackageListFiltered() {
            let filteredUpdatePackages = this.associationPackages;
            if (this.updateTypeFilter && this.updateTypeFilter.length) {
                filteredUpdatePackages = filteredUpdatePackages.filter((u: UpdatePackageAssociation) => this.updateTypeFilter.includes(u.updateType));
            }
            return filteredUpdatePackages;
        },
    },
    watch: {
        installations() {
            this.fetchAssociatedUpdatePackages();
            this.options = {};
            this.backToTheFirst();
        },
    },
    methods: {
        ...mapActions([a.ON_UPDATE_PACKAGE_PAGE_LOAD, a.FETCH_UPDATE_PACKAGES_LIST]),
        GetI18nStringFromUpdateType,
        async save() {
            this.loading = true;

            let reqData = new SetInstallationsPackagesReqData();
            reqData.installationNames.splice(0, reqData.installationNames.length, ...this.installations.map((c) => c.name));
            reqData.enabledPackageIds.splice(
                0,
                reqData.enabledPackageIds.length,
                ...this.associationPackages.filter((c) => c.association == UpdatePackageAssociationEnum.all).map((c) => c.id)
            );
            reqData.disabledPackageIds.splice(
                0,
                reqData.disabledPackageIds.length,
                ...this.associationPackages.filter((c) => c.association == UpdatePackageAssociationEnum.none).map((c) => c.id)
            );

            await new SetInstallationsPackagesCommand(reqData).execute();

            this.loading = false;

            await this.fetchAssociatedUpdatePackages();

            this.$emit("data-reload");
        },
        async fetchAssociatedUpdatePackages() {
            console.log("fetchAssociatedUpdatePackages called");
            this.loading = true;

            // svuoto l'array così viene verranno renderizzati i nuovi componenti
            this.associationPackages.splice(0, this.associationPackages.length);
            this.originalAssociationPackages.splice(0, this.originalAssociationPackages.length);

            let reqData = new FetchAssociatedUpdatePackagesReqData();
            reqData.installationNames = this.installations.map((c) => c.name);

            let resData = await new FetchAssociatedUpdatePackagesCommand(reqData).execute();

            // inserisco i nuovi risultati nell'array associationPackages
            this.associationPackages.splice(0, this.associationPackages.length, ..._.cloneDeep(resData.associationPackages));
            this.originalAssociationPackages.splice(0, this.originalAssociationPackages.length, ..._.cloneDeep(resData.associationPackages));

            this.loading = false;
        },
        filterChanged(filters) {
            this.backToTheFirst();
            let updateFilter = filters.filter((f) => f.filterKey == "updateTypeFilter");
            if (updateFilter.length == 1) {
                this.updateTypeFilter = updateFilter[0].currentSelections;
            }
        },
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },
    },
    mounted() {
        this.fetchAssociatedUpdatePackages();
        this[a.ON_UPDATE_PACKAGE_PAGE_LOAD]();
        this[a.FETCH_UPDATE_PACKAGES_LIST]();
    },
});
